var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info_heading"},[_c('h5',[_vm._v(_vm._s(_vm.heading)+" "),(_vm.span)?_c('span',[_vm._v("("+_vm._s(_vm.span)+")")]):_vm._e()]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }